import CloseIcon from "@mui/icons-material/Close";
import { Box, Chip, TextField, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { useMemo } from "react";

export const Label = styled("label")`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
  font-weight: bold;
  color: #000;
`;

export default function CustomizedHook({
  label,
  placeholder,
  options,
  value,
  onChange,
  multiple,
  width,
  maxWidth,
  notShowValue,
  readOnly = false,
  parentWidth = "48%",
}) {
  const processedOptions = useMemo(() => {
    if (!options || options.length === 0) return [];

    // شمارش تعداد تکرار هر نام
    const nameCount = {};
    options.forEach((option) => {
      const name = option?.name || option?.title || option?.value || "";
      nameCount[name] = (nameCount[name] || 0) + 1;
    });

    // ذخیره تعداد دفعاتی که هر نام دیده شده
    const nameIndex = {};

    return options.map((option) => {
      const name = option?.name || option?.title || option?.value || "";

      // اگر نام تکراری است، شماره اندیس اضافه کن
      if (nameCount[name] > 1) {
        nameIndex[name] = (nameIndex[name] || 0) + 1;
        return {
          ...option,
          displayName: `${name} ${nameIndex[name]}`,
        };
      }

      return {
        ...option,
        displayName: name,
      };
    });
  }, [options]);

  return (
    <>
      <Box width={parentWidth}>
        <Typography
          color={"text.primary"}
          sx={{
            fontSize: "13px",
            fontStyle: "normal",
            // fontWeight: "bold",
            lineHeight: "18px",
            mb: "5px",
          }}
        >
          {label}
        </Typography>
        <Autocomplete
          readOnly={readOnly}
          clearOnEscape={true}
          sx={{
            "& .MuiInputBase-root": {
              padding: "2px !important",
              width: width || "50%",
              borderRadius: "8px",
              border: "solid 1px var(--emr-borderInput)",
              // background: "#f3f3f3",
              // height: "36px",
              outline: "none",
              "& .MuiButtonBase-root": {
                borderRadius: "8px",
                display: notShowValue ? "none" : "",
              },
              "& .MuiInputBase-input": {
                height: "17px",
              },
            },
          }}
          popupIcon={<></>}
          clearIcon={<></>}
          multiple={multiple === undefined ? false : multiple}
          id="fixed-tags-demo"
          value={value}
          onChange={onChange}
          options={processedOptions}
          getOptionLabel={(option) => {
            if (typeof option === "string") return option;
            return (
              option.displayName ||
              option.name ||
              option.title ||
              option.value ||
              ""
            );
          }}
          isOptionEqualToValue={(option, value) => {
            return option?.id === value?.id;
          }}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                key={index}
                sx={{
                  "& .MuiSvgIcon-root": {
                    marginLeft: "5px",
                    marginRight: "-4px",
                  },
                }}
                deleteIcon={<CloseIcon />}
                label={option?.title || option?.name || option?.value}
                {...getTagProps({ index })}
                // disabled={fixedOptions.indexOf(option) !== -1}
              />
            ))
          }
          style={{ width: maxWidth || 500 }}
          renderInput={(params) => (
            <TextField {...params} placeholder={placeholder} />
          )}
        />
      </Box>
    </>
  );
}
